import client from '@/apis/http-client'
import Vue from 'vue'
import qs from 'qs'

const pathUrl = `/por/api`

// Initial state.
const defaultState = () => {
    return {
        textSearch: '',
        isLoading: false,
        appointmentList: [],
        currentPage: 1,
        total: 0,
        pageSize: 25,
        sortBy: 'update_date',
        sortDesc: 'DESC',
        options: {},
        appointmentSettingObject: {
            'codename': '',
            'bu_code': '',
            'name_en': '',
            'name_th': '',
            'support_emails': null,
            'support_line_group_id': null,
            'create_date': '',
            'update_date': '',
            'create_by': null,
            'update_by': null,
            'create_by_user': null,
            'update_by_user': null,
            'last_modified_by': null,
            'last_modified_date': null
        }
    }
}

// State
let state = defaultState()

// Actions
const actions = {
    resetList({ commit }) {
        commit('RESET_LIST_STATE')
    },
    resetState({ commit }) {
        commit('RESET_STATE')
    },
    setPage({ commit }, page) {
        commit('SET_PAGE', page)
    },
    setPageSize({ commit }, size) {
        commit('SET_PAGE_SIZE', size)
    },
    setTextSearch({ commit }, text) {
        if (text == state.textSearch) return
        commit('SET_TEXT_SEARCH', text)
    },
    setFieldSort({ commit }, field) {
        if (field) {
            commit('SET_FIELD_SORT', field)
        } else {
            commit('SET_FIELD_SORT', defaultState().sortBy)
        }
    },
    setSort({ commit }, sort) {
        commit('SET_SORT', sort === undefined ? 'DESC' : sort ? 'DESC' : 'ASC')
    },
    async getAppointmentSetting({ commit }, org_codename) {
        commit('SET_IS_LOADING', true)
        try {
            let data = await client.secureHttpClient.get(`${pathUrl}/appointments-setting/${org_codename}`)
            commit('SET_APPOINTMENT_SETTING_OBJECT', data.data)
            commit('SET_IS_LOADING', false)
        } catch (e) {
            Vue.$log.error(e)
            commit('SET_IS_LOADING', false)
        }
    },
    async updateAppointmentSetting({ commit }, payload) {
        const { org_codename, data } = payload
        commit('SET_IS_LOADING', true)
        try {
            await client.secureHttpClient.put(`${pathUrl}/appointments-setting/${org_codename}`, data)
            commit('SET_IS_LOADING', false)
            return true
        } catch (e) {
            Vue.$log.error(e)
            commit('SET_IS_LOADING', false)
            return false
        }
    },
    // API calls
    async fetch({ commit }) {
        const {
            currentPage,
            pageSize,
            textSearch,
            sortBy,
            sortDesc
        } = state
        commit('SET_IS_LOADING', true)
        try {
            const params = {
                page: currentPage,
                limit: pageSize,
                q: `${encodeURIComponent(textSearch)}`,
                orderBy: sortBy,
                sort: sortDesc,
                is_active: '1',
            }
            let data = await client.secureHttpClient.get(`${pathUrl}/appointments-setting`, {
                params,
                paramsSerializer: params => qs.stringify(params, { encode: false })
            })
            commit('SET_TOTAL', data.data.total)
            commit('SET_APPOINTMENTS_LIST', data.data.results)
            commit('SET_IS_LOADING', false)
        } catch (e) {
            Vue.$log.error(e)
            commit('SET_IS_LOADING', false)
        }
    }
}

// Mutations
const mutations = {
    RESET_LIST_STATE(state) {
        state.currentPage = defaultState().currentPage
        state.pageSize = defaultState().pageSize
        state.textSearch = defaultState().textSearch
        state.sortBy = defaultState().sortBy
        state.sortDesc = defaultState().sortDesc
    },
    SET_IS_LOADING(state, isLoading) {
        state.isLoading = isLoading
    },
    SET_PAGE(state, page) {
        state.currentPage = page
    },
    SET_PAGE_SIZE(state, size) {
        state.pageSize = size
    },
    SET_TEXT_SEARCH(state, text) {
        state.textSearch = text
    },
    SET_TOTAL(state, total) {
        state.total = total
    },
    SET_APPOINTMENTS_LIST(state, appointments) {
        state.appointmentList = appointments
    },
    SET_FIELD_SORT(state, field) {
        state.sortBy = field
    },
    SET_SORT(state, sort) {
        state.sortDesc = sort
    },
    SET_APPOINTMENT_SETTING_OBJECT(state, data) {
        state.appointmentSettingObject = data
    },
    RESET_STATE(state) {
        state.appointmentSettingObject = defaultState().appointmentSettingObject
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
